var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpongebobSquarepants2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 192.756 192.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#e0e245",
    d: "M0 0h192.756v192.756H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.75 68.186c0 16.833-13.646 30.479-30.479 30.479S36.792 85.019 36.792 68.186c0-16.834 13.646-30.479 30.479-30.479 16.833-.001 30.479 13.645 30.479 30.479zM159.604 71.233c0 16.833-13.646 30.479-30.479 30.479-16.834 0-30.48-13.646-30.48-30.479s13.646-30.479 30.48-30.479c16.832 0 30.479 13.645 30.479 30.479z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2.913,
    strokeMiterlimit: 2.613
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.807 68.186c0 7.912-6.413 14.325-14.325 14.325-7.912 0-14.325-6.413-14.325-14.325 0-7.912 6.413-14.325 14.325-14.325 7.912-.001 14.325 6.412 14.325 14.325z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5ea3db",
    stroke: "#000",
    strokeWidth: 1.457,
    strokeMiterlimit: 2.613
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.577 68.186a6.095 6.095 0 1 1-12.19 0 6.095 6.095 0 0 1 12.19 0z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.02 70.318c0 7.912-6.412 14.325-14.324 14.325S105.37 78.23 105.37 70.318c0-7.911 6.414-14.324 14.326-14.324s14.324 6.413 14.324 14.324z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5ea3db",
    stroke: "#000",
    strokeWidth: 1.457,
    strokeMiterlimit: 2.613
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.789 70.318a6.095 6.095 0 0 1-6.094 6.096 6.097 6.097 0 1 1 6.094-6.096z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.536 93.483s20.421 23.163 55.167 23.163c34.745 0 59.433-20.421 59.433-20.421s-5.182 58.215-61.872 58.215c-45.414 0-52.728-60.957-52.728-60.957z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.457,
    strokeMiterlimit: 2.613
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.536 93.483s20.421 23.163 55.167 23.163c34.745 0 59.433-20.421 59.433-20.421s-5.182 58.215-61.872 58.215c-45.414 0-52.728-60.957-52.728-60.957z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.913,
    strokeMiterlimit: 2.613
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.911 94.702l1.524-8.838c3.962-12.801 16.458-6.401 16.763-.305l.916 9.753-19.203-.61z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#e0e245",
    stroke: "#000",
    strokeWidth: 2.913,
    strokeMiterlimit: 2.613
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.641 41.06l-3.962-10.362m18.897-3.05l-.609 10.059m20.115-6.401l-5.791 8.839m35.965 3.048l-3.963-10.362m18.896-2.439l-.609 10.058m19.506-3.962l-5.791 8.839",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4.129,
    strokeMiterlimit: 2.613
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.658 96.227s.305-7.314 9.144-7.01m108.659 3.2s7.314.304 7.01 9.144",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.913,
    strokeMiterlimit: 2.613
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    d: "M76.11 115.732l-4.267 11.887 17.678 4.267 3.657-13.715-17.068-2.439zM98.969 118.476l16.459-2.439 1.83 15.849H98.969v-13.41z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.918 143.468s19.2-10.666 28.954.305c12.801-12.8 28.651 3.963 28.651 3.963s-32.307 17.37-57.605-4.268z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#d14f2e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpongebobSquarepants2);
export default __webpack_public_path__ + "static/media/spongebob-squarepants-2.024c7d39b29826d58545fb3844fd19bd.svg";
export { ForwardRef as ReactComponent };